// Format "HH:MM" (24-hour) into "h:MM AM/PM" for display.
// We keep stored times as 24-hour ISO so the backend stays simple — only the
// UI converts to 12-hour. Handles edge cases: midnight → "12:00 AM", noon →
// "12:00 PM", invalid input → returns the raw string.
export function fmt12(time24) {
  if (!time24 || typeof time24 !== "string") return time24 || "";
  const m = time24.match(/^(\d{1,2}):(\d{2})/);
  if (!m) return time24;
  let h = parseInt(m[1], 10);
  const mm = m[2];
  if (Number.isNaN(h)) return time24;
  const period = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${mm} ${period}`;
}
